<template>
  <div class="rotating-loader-wrapper">
    <div class="rotating-loader" :style="{ width: size + 'px', height: size + 'px' }">
      <svg
        class="loader-svg"
        viewBox="0 0 50 50"
        :style="{ animationDuration: speed + 's' }"
      >
        <defs>
          <linearGradient id="gradient-stroke" x1="1" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#FF00C3" />
            <stop offset="100%" stop-color="#FF7800" />
          </linearGradient>
        </defs>

        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="none"
          :stroke-width="strokeWidth"
        />

        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="url(#gradient-stroke)"
          :stroke-width="strokeWidth"
          stroke-linecap="round"
          stroke-dasharray="100"
          stroke-dashoffset="10"
        />
      </svg>
    </div>
    <div v-if="label" class="loader-label">
      {{ label }}
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  size: {
    type: [Number, String],
    default: 30,
  },
  strokeWidth: {
    type: Number,
    default: 5,
  },
  speed: {
    type: Number,
    default: 0.6, // seconds
  },
  label: {
    type: String,
    default: '', // optional label
  }
})
</script>

<style scoped>
.rotating-loader-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rotating-loader {
  display: inline-block;
}

.loader-svg {
  width: 100%;
  height: 100%;
  animation: rotate linear infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

.loader-label {
  margin-top: 8px;
  font-size: 0.875rem;
  color: #333;
}
</style>
